import { AxiosRequestConfig, AxiosResponse } from 'axios'

import apiClient from '@/core/api/client'
import { publicApiClient } from '@/core/api/client'

export const brandIdentityService = {
	getBrandIdentities(config?: AxiosRequestConfig): Promise<AxiosResponse> {
		return apiClient.get('/brand_identities', config)
	},
	getCulturalIdentities(config?: AxiosRequestConfig): Promise<AxiosResponse> {
		return publicApiClient.get('/cultural_identities', config)
	},
}
